import { LocalDate } from '../../core/model/local-date';
import { ModelBase } from '../../core/model/model-base';
import { AreaType } from './const/enums';

export class Area extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      this.measuredBy = dataContext.name;
      this.id = dataContext.id;
      this.building = dataContext.building;
      this.property = dataContext.property;
      this.rentalObject = dataContext.rentalObject;
      this.value = dataContext.value;
    }

    Object.defineProperties(this, {
      _measuredDate: { writable: true, enumerable: false },
    });
  }

  private _measuredDate: LocalDate;

  property: string;
  building: string;
  rentalObject: string;
  type: AreaType;
  value: number;
  measuredBy: string;

  get measuredDate(): LocalDate {
    return this._measuredDate;
  }
  set measuredDate(value: LocalDate) {
    this._measuredDate = LocalDate.fromDate(value);
  }

  toJSON() {
    let json = Object.assign({}, this);
    json.measuredDate = this.measuredDate;
    return json;
  }

  toString() {
    return this.measuredBy;
  }
}
